import { normalizeClassId } from './classIdentity.mjs';

// Placeholder rows that stand in for the subclass choice. The subclass registry supplies the real features for
// supported classes. Server rows carry `subclassPlaceholder: true`; the 2014 names cover older data.
const LEGACY_SUBCLASS_PLACEHOLDERS = Object.freeze({
  barbarian: ['primal path', 'primal path feature'],
  fighter: ['martial archetype', 'martial archetype feature'],
  monk: ['monastic tradition', 'monastic tradition feature'],
  rogue: ['roguish archetype', 'roguish archetype feature'],
  ranger: ['ranger archetype', 'ranger archetype feature'],
  paladin: ['sacred oath', 'sacred oath feature'],
  cleric: ['cleric subclass'],
  wizard: ['wizard subclass'],
  bard: ['bard subclass'],
});

/** True when a class feature row can be shown: anything but a subclass placeholder. */
export const isClassFeatureDisplayable = (feature) => {
  if (feature?.subclassPlaceholder === true) return false;
  const classId = normalizeClassId(feature?.class ?? feature?.classId ?? feature?.source?.classId);
  const name = String(feature?.name ?? '').trim().toLowerCase();
  return !(LEGACY_SUBCLASS_PLACEHOLDERS[classId] || []).includes(name);
};
